/* eslint-disable prettier/prettier */
const globals = {
	floats: {
		left: 'float-left',
		right: 'float-right',
	},
	positions: {
		left: 'left-0',
		right: 'right-0',
		top: 'top-0',
		bottom: 'bottom-0',
	},
	aspectRatios: {
		auto: 'aspect-auto',
		'1/1': 'aspect-[1/1]',
		'16/9': 'aspect-[16/9]',
		'21/9': 'aspect-[21/9]',
		'4/3': 'aspect-[4/3]',
	},
	fontSizes: {
		xs: 'text-xs',
		sm: 'text-sm',
		base: 'text-base',
		md: 'text-md',
		lg: 'text-lg',
		xl: 'text-xl',
		'2xl': 'text-2xl',
		'3xl': 'text-3xl',
		'4xl': 'text-4xl',
		'5xl': 'text-5xl',
	},
	justifyContent: {
		normal: 'justify-normal',
		start: 'justify-start',
		end: 'justify-end',
		center: 'justify-center',
		between: 'justify-between',
		around: 'justify-around',
		evenly: 'justify-evenly',
		stretch: 'justify-stretch',
	},
	surfaceColors: {
		primary: 'bg-primary-surface',
		secondary: 'bg-secondary-surface',
		neutral: 'bg-neutral-surface',
		info: 'bg-info-surface',
		warning: 'bg-warning-surface',
		danger: 'bg-danger-surface',
		success: 'bg-success-surface',
	},
	onSurfaceColors: {
		primary: 'text-primary-on-surface',
		secondary: 'text-secondary-on-surface',
		neutral: 'text-neutral-on-surface',
		info: 'text-info-on-surface',
		warning: 'text-warning-on-surface',
		danger: 'text-danger-on-surface',
		success: 'text-success-on-surface',
	},
	icons: {
		strike: 'bx-strikethrough',
		underline: 'bx-underline',
		code: 'bx-code',
		ul: 'bx-list-ul',
		ol: 'bx-list-ol',
		quote: 'bxs-quote-left',
		hr: 'bx-minus',
		undo: 'bx-undo',
		redo: 'bx-redo',
		zoom: 'bx-zoom-in',
		'zoom-out': 'bx-zoom-out',
		'rotate-right': 'bx-rotate-right',
		'rotate-left': 'bx-rotate-left',
		image: 'bx-image-alt',
		images: 'bx-images',
		home: 'bx-home',
		firstPage: 'bx-first-page',
		previousPage: 'bx-chevron-left',
		nextPage: 'bx-chevron-right',
		lastPage: 'bx-last-page',
		map: 'bx-map',
		navigation: 'bxs-navigation',
		mail: 'bxs-envelope',
		menu: 'bx-menu',
		phone: 'bxs-phone',
		mobile: 'bx-mobile',
		event: 'bx-calendar-event',
		date: 'bx-calendar-alt',
		printer: 'bxs-printer',
		user: 'bx-user',
		search: 'bx-search',
		'chevron-left': 'bx-chevron-left',
		'chevron-right': 'bx-chevron-right',
		'chevron-up': 'bx-chevron-up',
		'chevron-down': 'bx-chevron-down',
		'caret-right': 'bx-caret-right',
		'arrow-right': 'bx-right-arrow-alt',
		'arrow-left': 'bx-left-arrow-alt',
		'arrow-up': 'bx-up-arrow-alt',
		'arrow-down': 'bx-down-arrow-alt',
		plus: 'bx-plus',
		purchase: 'bx-purchase-tag-alt',
		minus: 'bx-minus',
		check: 'bx-check',
		info: 'bx-info-circle',
		group: 'bx-group',
		copyright: 'bxs-copyright',
		trash: 'bx-trash-alt',
		library: 'bx-library',
		loader: 'bx-loader-alt',
		bell: 'bx-bell',
		time: 'bx-time',
		'hard-hat': 'bx-hard-hat',
		x: 'bx-x',
		error: 'bx-message-error',
		alarm: 'bx-alarm-exclamation',
		file: 'bxs-file',
		'file-pdf': 'bxs-file-pdf',
		'file-image': 'bxs-file-image',
		'file-doc': 'bxs-file-doc',
		'file-txt': 'bxs-file-txt',
		filter: 'bx-filter-alt',
		link: 'bx-link',
		unlink: 'bx-unlink',
		'link-external': 'bx-link-external',
		download: 'bxs-download',
		volume: 'bxs-volume-full',
		news: 'bx-news',
		'book-reader': 'bx-book-reader',
		pause: 'bx-pause',
		play: 'bx-play',
		facebook: 'bxl-facebook',
		youtube: 'bxl-youtube',
		instagram: 'bxl-instagram',
		twitter: 'bxl-twitter',
		flickr: 'bxl-flickr',
		'bx-objects-horizontal-center': 'bx-objects-horizontal-center',
		child: 'bx-child',
		'universal-access': 'bx-universal-access',
		fork: 'bx-fork',
		party: 'bx-party',
		buildings: 'bx-building',
		chat: 'bx-chat',
		'edit-alt': 'bx-edit-alt',
		'book-open': 'bx-book-open',
		parking: 'bx-parking',
		comment: 'bx-comment',
		'lock-alt': 'bx-lock-alt',
		school: 'bx-school',
		exit: 'bx-exit',
		heart: 'bx-heart',
		cart: 'bx-cart',
		'log-in': 'bx-log-in',
		water: 'bx-water',
		football: 'bx-football',
		grid: 'bx-grid-alt',
		briefcase: 'bx-briefcase',
		'bx-calendar_zeitstrahl_termin': 'bx-calendar',
		'bx-calendar-event_zeitstrahl_veranstaltung': 'bx-calendar-event',
		'bx-chat_zeitstrahl_buergerbeteiligung': 'bx-chat',
		'bx-wrench_zeitstrahl_baubeginn': 'bx-wrench',
		'bx-receipt_zeitstrahl_rechtspruefung': 'bx-receipt',
		'bx-images_zeitstrahl_bildergalerie': 'bx-images',
		'bx-bookmark_zeitstrahl_einweihung': 'bx-bookmark',
		'bx-check_zeitstrahl_projektabschluss': 'bx-check',
		'bx-hard-hat_zeitstrahl_projektstart': 'bx-hard',
		globe: 'bx-globe',
		'snow': 'bx-cloud-snow',
		'rain': 'bx-cloud-rain',
		'cloud': 'bx-cloud',
		'sun': 'bx-sun',
		leave: 'bx-up-arrow-alt transform rotate-45',
	},
};

const settings = {
	NkAccordion: {
		iconClosed: 'minus',
		iconOpen: 'plus',
		iconTransitionName: 'fade',
		iconSize: 'md',
		titleSizes: globals.fontSizes,
		variants: {
			default: {
				wrapper: 'nk-accordion',
				header:
					'group block border-b text-neutral-text-high-contrast border-neutral-50 py-2 px-4 hover:text-neutral-text-high-contrast--hover focus:text-neutral-text-high-contrast--active bg-secondary-800/10',
				content: 'py-4',
			},
			solid: {
				wrapper: 'nk-accordion',
				header:
					'group block border-b border-primary-border py-3 px-4 bg-primary-element hover:bg-primary-element--hover focus:bg-primary-element--hover text-primary-on-element--high-contrast hover:text-primary-on-element focus:text-primary-on-element transition duration-300',
				content: 'py-4 px-1',
			},
		},
	},
	NkLink: {
		classes:
			'inline-block [&>.nk-title]:!mb-0 text-primary-element hover:text-primary-element--hover focus:outline-4 transform duration-150',
	},
	NkBreadcrumb: {
		classes: {
			wrapper: 'flex justify-center',
			container: 'container',
			list: 'flex items-center py-2',
			item: 'text-base after:content-["»"] after:mx-2 after:text-neutral-400 last:after:hidden',
			link: 'text-secondary-600 hover:text-secondary-500 font-medium',
			currentPage: 'text-neutral-600 font-light',
			homeTitle: '',
		},
		homeIcon: {
			icon: 'home',
			variant: 'boxed',
			backgroundColor: true,
			color: 'primary',
			class: 'hidden',
		},
	},
	NkBadge: {
		fixedClasses: 'cursor-default inline-block px-8 font-semibold uppercase',
		surfaceColors: globals.surfaceColors,
		onSurfaceColors: globals.onSurfaceColors,
		sizes: {
			sm: 'text-sm',
			base: 'text-sm',
			md: 'text-md',
			lg: 'text-lg',
		},
	},
	NkBox: {
		variants: {
			default: 'mb-3',
			transparent: 'px-4 py-3',
			sidebar: 'p-4 border-t border-dashed border-neutral-300 first:border-none',
		},
	},
	NkButton: {
		fixedClasses:
			'inline-flex items-center transition duration-300 ease-out font-medium relative rounded no-underline',
		disabled: 'opacity-50 cursor-not-allowed',
		expand: 'block w-full text-center justify-center',
		loading: 'relative',
		prependIconAttributes: {
			class: 'mr-1',
		},
		appendIconAttributes: {
			class: 'ml-1',
		},
		variants: {
			solid: 'nk-solid',
			outline: 'nk-outline border',
			link: 'nk-link',
			ghost: 'nk-ghost',
			footer: 'nk-footer',
		},
		colors: {
			primary:
				'[&.nk-solid]:bg-primary-element [&.nk-solid]:hover:bg-primary-element--hover [&.nk-solid]:focus:bg-primary-element--active [&.nk-solid]:text-primary-on-element [&.nk-link]:border-primary-element [&.nk-link]:text-primary-text [&.nk-link]:hover:text-primary-text--hover [&.nk-link]:hover:border-primary-element--hover [&.nk-ghost]:text-primary-text [&.nk-ghost]:hover:text-primary-text--hover [&.nk-ghost]:hover:border-primary-element--hover [&.nk-outline]:border-primary-element [&.nk-outline]:text-primary-text [&.nk-outline]:hover:text-primary-text--hover [&.nk-outline]:hover:border-primary-element--hover',
			secondary:
				'[&.nk-solid]:bg-secondary-element [&.nk-solid]:hover:bg-secondary-element--hover [&.nk-solid]:focus:bg-secondary-element--active [&.nk-solid]:text-secondary-on-element [&.nk-link]:border-secondary-element [&.nk-link]:text-secondary-text [&.nk-link]:hover:text-secondary-text--hover [&.nk-link]:hover:border-secondary-element--hover [&.nk-ghost]:text-secondary-text [&.nk-ghost]:hover:text-secondary-text--hover [&.nk-ghost]:hover:border-secondary-element--hover [&.nk-outline]:border-secondary-element [&.nk-outline]:text-secondary-text [&.nk-outline]:hover:text-secondary-text--hover [&.nk-outline]:hover:border-secondary-element--hover',
			neutral:
				'[&.nk-solid]:bg-neutral-element [&.nk-solid]:hover:bg-neutral-element--hover [&.nk-solid]:focus:bg-neutral-element--active [&.nk-solid]:text-neutral-on-element [&.nk-link]:border-neutral-element [&.nk-link]:text-neutral-text [&.nk-link]:hover:text-neutral-text--hover [&.nk-link]:hover:border-neutral-element--hover [&.nk-ghost]:text-neutral-text [&.nk-ghost]:hover:text-secondary-text--hover [&.nk-ghost]:hover:border-neutral-element--hover [&.nk-outline]:border-neutral-element [&.nk-outline]:text-neutral-text [&.nk-outline]:hover:text-neutral-text--hover [&.nk-outline]:hover:border-neutral-element--hover [&.nk-footer]:text-neutral-400 [&.nk-footer]:hover:text-neutral-300 [&.nk-footer]:focus:outline-white [&.nk-footer.nk-link]:text-neutral-400 [&.nk-footer.nk-link]:hover:text-neutral-300 [&.nk-footer.nk-link]:focus:outline-white',
			danger:
				'[&.nk-solid]:bg-danger-element [&.nk-solid]:hover:bg-danger-element--hover [&.nk-solid]:focus:bg-danger-element--active [&.nk-solid]:text-danger-on-element [&.nk-link]:border-danger-element [&.nk-link]:text-danger-text [&.nk-link]:hover:text-danger-text--hover [&.nk-link]:hover:border-danger-element--hover [&.nk-ghost]:text-danger-text [&.nk-ghost]:hover:text-danger-text--hover [&.nk-ghost]:hover:border-danger-element--hover [&.nk-outline]:border-danger-element [&.nk-outline]:text-danger-text [&.nk-outline]:hover:text-danger-text--hover [&.nk-outline]:hover:border-danger-element--hover',
			success:
				'[&.nk-solid]:bg-success-element [&.nk-solid]:hover:bg-success-element--hover [&.nk-solid]:focus:bg-success-element--active [&.nk-solid]:text-success-on-element [&.nk-link]:border-success-element [&.nk-link]:text-success-text [&.nk-link]:hover:text-success-text--hover [&.nk-link]:hover:border-success-element--hover [&.nk-ghost]:text-success-text [&.nk-ghost]:hover:text-success-text--hover [&.nk-ghost]:hover:border-success-element--hover [&.nk-outline]:border-success-element [&.nk-outline]:text-success-text [&.nk-outline]:hover:text-success-text--hover [&.nk-outline]:hover:border-success-element--hover',
			info: '[&.nk-solid]:bg-info-element [&.nk-solid]:hover:bg-info-element--hover [&.nk-solid]:focus:bg-info-element--active [&.nk-solid]:text-info-on-element [&.nk-link]:border-info-element [&.nk-link]:text-info-text [&.nk-link]:hover:text-info-text--hover [&.nk-link]:hover:border-info-element--hover [&.nk-ghost]:text-info-text [&.nk-ghost]:hover:text-info-text--hover [&.nk-ghost]:hover:border-info-element--hover [&.nk-outline]:border-info-element [&.nk-outline]:text-info-text [&.nk-outline]:hover:text-info-text--hover [&.nk-outline]:hover:border-info-element--hover',
			warning:
				'[&.nk-solid]:bg-warning-element [&.nk-solid]:hover:bg-warning-element--hover [&.nk-solid]:focus:bg-warning-element--active [&.nk-solid]:text-warning-on-element [&.nk-link]:border-warning-element [&.nk-link]:text-warning-text [&.nk-link]:hover:text-warning-text--hover [&.nk-link]:hover:border-warning-element--hover [&.nk-ghost]:text-warning-text [&.nk-ghost]:hover:text-warning-text--hover [&.nk-ghost]:hover:border-warning-element--hover [&.nk-outline]:border-warning-element [&.nk-outline]:text-warning-text [&.nk-outline]:hover:text-warning-text--hover [&.nk-outline]:hover:border-warning-element--hover',
			white:
				'[&.nk-solid]:bg-white-element [&.nk-solid]:hover:bg-white-element--hover [&.nk-solid]:focus:bg-white-element--active [&.nk-solid]:text-white-on-element [&.nk-link]:underline [&.nk-link]:border-white-element [&.nk-link]:text-white [&.nk-link]:hover:text-white/75 [&.nk-link]:hover:border-white-element--hover [&.nk-ghost]:text-white-text [&.nk-ghost]:hover:text-white-text--hover [&.nk-ghost]:hover:border-white-element--hover [&.nk-outline]:border-white-element [&.nk-outline]:text-white-text [&.nk-outline]:hover:text-white-text--hover [&.nk-outline]:hover:border-white-element--hover [&.nk-footer]:text-white [&.nk-footer]:font-light [&.nk-footer]:hover:opacity-80 [&.nk-footer] [&.nk-footer]:focus:outline-white',
		},
		sizes: {
			default: 'px-8 py-4 min-h-8 text-base',
			sm: 'px-3 py-2 text-sm',
			md: 'p-3 text-md',
			lg: 'p-3 text-lg',
			collapse: 'p-0 rounded-none',
		},
	},
	NkCard: {
		fixedClasses: 'nk-card',
		variants: {
			default: {
				wrapper: 'flex flex-col min-h-full h-full gap-3',
				body: 'py-3 flex flex-col h-full gap-3',
				header: '',
				image: '',
				footer: 'mt-auto',
				link: '[&_.nk-title]:text-primary-text [&_.nk-title]:underline transition-all duration-300 ease-out',
			},
			row: {
				wrapper: 'flex flex-wrap min-h-full',
				body: 'w-full md:flex-1 p-6 bg-neutral-surface flex flex-col gap-3',
				header: 'w-full md:flex-1',
				image: 'w-full md:flex-1',
				footer: 'pt-5 mt-auto',
				link: '',
			},
			boxed: {
				wrapper:
					'flex flex-col min-h-full h-full justify-between bg-white flex flex-col',
				body: 'flex flex-col gap-3 p-6 h-full',
				header: 'px-6 pt-6 last:pb-6',
				image: '',
				footer: 'mt-auto p-4 pt-0',
				link: 'transition duration-300 ease-out transform hover:-translate-y-1 hover:text-neutral-on-surface hover:bg-neutral-surface--active focus:text-neutral-on-surface focus:shadow-md focus:bg-neutral-surface--active',
			},
			imagePreview: {
				wrapper:
					'flex flex-col min-h-full h-full justify-between bg-neutral-surface flex flex-col',
				body: 'flex flex-col gap-3 p-6 h-full',
				header: '',
				image: '',
				footer: 'mt-auto p-4 pt-0',
				link: 'transition duration-300 ease-out transform hover:-translate-y-1 hover:text-neutral-on-surface hover:bg-neutral-surface--active focus:text-neutral-on-surface focus:shadow-md focus:bg-neutral-surface--active',
			},
			imageOverlay: {
				wrapper: 'block relative overflow-hidden',
				body: 'absolute bottom-0 left-0 w-full px-5 pb-6 pt-10 text-white bg-gradient-to-t from-black/75 to-black/0 text-shadow-sm flex flex-col gap-3',
				header: '',
				image: '',
				footer: '',
				link: 'transition transform duration-300 ease-out hover:-translate-y-1 hover:shadow-md focus:-translate-y-1 focus:shadow-md',
			},
		},
	},
	NkCarousel: {
		variants: {
			default: {
				sliderOptions: {
					spaceBetween: 16,
					slidesPerView: 1.25,
					centeredSlides: true,
					autoplay: {
						delay: 2500,
					},
					breakpoints: {
						640: {
							slidesPerView: 2,
							spaceBetween: 16,
							centeredSlides: false,
						},
						768: {
							slidesPerView: 2,
							spaceBetween: 24,
							centeredSlides: false,
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 24,
							centeredSlides: false,
						},
						1280: {
							slidesPerView: 3,
							spaceBetween: 24,
							centeredSlides: false,
						},
						1600: {
							slidesPerView: 4,
							spaceBetween: 24,
							centeredSlides: false,
						},
					},
				},
				wrapper: 'relative [&>*]:!py-2',
				slider: 'sm:overflow-hidden',
				sliderItem: 'flex items-center justify-center px-4 mb-20',
				slideContent: 'h-full w-full flex flex-col items-start',
				slideBackgroundImage: '',
				slideBackgroundImageContainer: '',
				controls:
					'absolute left-1/2 transform -translate-x-1/2 flex z-10 top-auto bottom-0 left-0 justify-center items-center p-4',
				buttonWrapper: 'flex justify-center items-center mx-8',
				button:
					'transition justify-center items-center text-center text-neutral-900 text-lg inline-flex opacity-100 hover:opacity-80 scale-100 hover:scale-110 flex justify-center items-center',
				buttonLeft: 'left-0 text-md',
				buttonLeftIcon: 'chevron-left',
				buttonRight: 'right-0 text-md',
				buttonRightIcon: 'chevron-right',
				buttonDisabled: 'opacity-30 cursor-not-allowed hover:!scale-100 hover:!opacity-30',
				paginationWrapper: 'flex justify-center items-center gap-1 z-20',
				pagination: 'flex flex-wrap items-end list-none justify-center gap-1',
				paginationButton:
					'relative size-5 before:absolute before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:size-3 before:rounded-full before:border-2 before:border-neutral-900 before:pointer-events-none hover:before:opacity-80 before:scale-100 hover:before:scale-110 before:transition',
				paginationButtonActive: 'is-active before:bg-neutral-900',
			},
			ghost: {
				sliderOptions: {
					spaceBetween: 0,
					slidesPerView: 1,
					centeredSlides: true,
					autoplay: {
						delay: 5000,
					},
				},
				wrapper: 'relative',
				slider: 'sm:overflow-hidden',
				sliderItem: 'flex items-center justify-center',
				slideContent: 'h-full w-full pb-20',
				slideBackgroundImage: '',
				controls:
					'absolute bottom-5 w-full z-10 flex justify-center items-center gap-7 pl-1/2 lg:pl-[calc(100%*2/7)]',
				buttonWrapper: '',
				button:
					'transition ease-out duration-300 flex justify-center items-center text-center text-neutral-900 hover:text-neutral-900/60 text-lg',
				buttonLeft: 'left-0 hidden',
				buttonLeftIcon: 'chevron-left',
				buttonRight: 'right-0 hidden',
				buttonRightIcon: 'chevron-right',
				buttonDisabled: 'opacity-50 cursor-not-allowed',
				paginationWrapper: 'flex justify-center items-center gap-2 z-20',
				pagination:
					'flex justify-center items-center gap-2.5 md:justify-start list-none',
				paginationButton:
					'block size-3.5 rounded-full bg-neutral-900/20 hover:bg-neutral-900/40 is-active:bg-neutral-900 is-active:hover:bg-neutral-900/60 transition',
				paginationButtonActive: 'is-active',
			},
			topThema: {
				sliderOptions: {
					spaceBetween: 30,
					slidesPerView: 1,
					centeredSlides: true,
					autoplay: {
						delay: 10000,
					},
				},
				wrapper: 'relative [&>*]:!p-5 [&>*]:!-m-5 [&>*]:lg:!p-6 [&>*]:lg:!-m-6 000 [&>*>*]:flex [&>*>*>*]:grow-1',
				slider: '',
				sliderItem: 'flex items-center justify-center',
				slideContent: 'flex h-full w-full',
				slideBackgroundImage: '',
				controls:
					'absolute left-1/2 transform -translate-x-1/2 flex z-10 top-auto bottom-8 left-0 justify-center items-center gap-8 p-4',
				buttonWrapper: 'flex justify-center items-center',
				button:
					'transition justify-center items-center text-center text-neutral-900 text-lg inline-flex opacity-100 hover:opacity-80 scale-100 hover:scale-110 flex justify-center items-center',
				buttonLeft: 'left-0 text-md',
				buttonLeftIcon: 'chevron-left',
				buttonRight: 'right-0 text-md',
				buttonRightIcon: 'chevron-right',
				buttonDisabled: 'opacity-30 cursor-not-allowed hover:scale-100 hover:opacity-30',
				paginationWrapper: 'flex justify-center items-center gap-1 z-20',
				pagination: 'flex flex-wrap items-end list-none justify-center gap-1',
				paginationButton:
					'relative size-5 before:absolute before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:size-3 before:rounded-full before:border-2 before:border-neutral-900 before:pointer-events-none hover:before:opacity-80 before:scale-100 hover:before:scale-110 before:transition',
				paginationButtonActive: 'is-active before:bg-neutral-900',
			},
			hero: {
				sliderOptions: {
					spaceBetween: 0,
					slidesPerView: 1,
					speed: 600,
					centeredSlides: true,
					navigation: true,
					effect: 'slide',
					autoplay: {
						delay: 6000,
					},
					fadeEffect: {
						crossFade: true,
					},
				},
				wrapper: 'relative w-full bg-transparent aspect-[4/3] sm:aspect-[3/1] overflow-hidden',
				slider: 'h-full min-h-full',
				sliderItem: 'flex items-center [&>*>*>*]:aspect-[4/3] [&>*>*>*]:sm:aspect-none overflow-hidden',
				slideContent: 'absolute top-0 w-full flex justify-start items-center z-10 h-full [&>*:not(.image-container)]:z-10 [&>*>*]:flex [&>*>*]:flex-col [&>*>*]:items-start [&>*>*]:gap-4 [&>*>*>.nk-title]:text-3xl [&>*>*>.nk-title]:lg:text-5xl [&>*>*>.nk-title]:bg-secondary-800 [&>*>*>.nk-title]:px-2 [&>*>*>.nk-text]:bg-primary-600 [&>*>*>.nk-text]:text-md [&>*>*>.nk-text]:p-2 [&>*>*>.nk-text]:-order-1 [&>*>*>.nk-text]:!m-0 [&>*>*>.nk-text]:px-2 [&>*>*>.nk-text]:lg:px-4 [&>*>*>.nk-text]:py-1 [&>*>*>.nk-text]:lg:py-2 [&>*>*>.nk-text]:uppercase [&>*>*>.text-primary-element]:uppercase [&>*>*>.text-primary-element]:!py-2 [&>*>*>.text-primary-element]:!px-4 [&>*>*>.text-primary-element]:lg:!py-4 [&>*>*>.text-primary-element]:lg:!px-8 before:content-none sm:before:content-[""] before:block before:absolute before:left-0 before:-bottom-1 before:w-full before:h-40 before:lg:h-60 before:z-10 before:bg-gradient-to-t before:from-neutral-50 before:pointer-events-none',
				slideBackgroundImage: 'absolute left-1/2 top-1/2 h-full !w-auto max-w-none -translate-x-1/2 -translate-y-1/2 sm:static sm:translate-x-0 sm:translate-y-0',
				controls:
					'flex justify-center items-center gap-6 sm:px-2 py-2 static absolute sm:right-16 lg:right-4 bottom-0 sm:bottom-8 z-10 bg-white/20 sm:rounded-full sm:shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[5px] sm:border sm:border-white/30 w-full sm:w-auto',
				buttonWrapper: 'flex justify-center items-center',
				button:
					'transition justify-center items-center text-center text-white sm:text-neutral-900 text-lg inline-flex opacity-100 hover:opacity-80 scale-100 hover:scale-110',
				buttonLeft: 'text-md',
				buttonLeftIcon: 'chevron-left',
				buttonRight: 'text-md',
				buttonRightIcon: 'chevron-right',
				buttonDisabled: 'opacity-50 cursor-not-allowed',
				paginationWrapper: '',
				pagination: 'flex flex-wrap items-end list-none justify-center gap-1',
				paginationButton:
					'relative size-5 before:absolute before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:size-3 before:rounded-full before:border-2 before:border-white sm:before:border-neutral-900 before:pointer-events-none hover:before:opacity-80 before:scale-100 hover:before:scale-110 before:transition',
				paginationButtonActive: 'is-active before:bg-white sm:before:bg-neutral-900',
			},
			'hero-slim': {
				sliderOptions: {
					spaceBetween: 0,
					slidesPerView: 1,
					speed: 600,
					centeredSlides: true,
					navigation: false,
					effect: 'fade',
					autoplay: {
						delay: 10000,
					},
					fadeEffect: {
						crossFade: true,
					},
				},
				wrapper:
					'relative w-full bg-transparent overflow-hidden after:content-[""] after:absolute after:left-0 after:bottom-0 after:w-full after:h-40 after:z-10 after:bg-gradient-to-t after:from-neutral-50',
				slider: 'h-full min-h-full',
				sliderItem: 'flex items-center aspect-[4/3] sm:aspect-[2/1] md:aspect-[3/1] lg:aspect-[4.5/1]',
				slideContent:
					'relative z-10 py-10 px-3 max-w-screen-sm mx-auto text-center text-shadow-sm flex h-full items-center justify-center',
				slideBackgroundImage:
					'absolute top-0 left-0 object-cover lazyload h-full w-full',
				controls: 'hidden',
				buttonWrapper:
					'absolute bottom-0 right-0 hidden my-6 px-3 translate-y-1/2 transform z-20',
				button:
					'transition ease-out duration-300 justify-center items-center text-center text-white/50 text-xl hover:text-white/75 focus:text-white hidden sm:inline-flex',
				buttonLeft: '',
				buttonLeftIcon: 'chevron-left',
				buttonRight: '',
				buttonRightIcon: 'chevron-right',
				buttonDisabled: 'opacity-50 cursor-not-allowed pointer-events-none',
				paginationWrapper:
					'absolute w-full bottom-0 block z-10 my-6 translate-y-1/2 transform',
				pagination:
					'flex flex-wrap items-center list-none -mx-1 justify-center',
				paginationButton:
					'block w-8 is-active:w-10 h-3 mx-1 rounded bg-white/50 hover:bg-white/75 is-active:bg-white transition-all',
				paginationButtonActive: 'is-active',
			},
			'hero-portal': {
				sliderOptions: {
					spaceBetween: 0,
					slidesPerView: 1,
					speed: 600,
					centeredSlides: true,
					navigation: true,
					effect: 'slide',
					autoplay: {
						delay: 6000,
					},
					fadeEffect: {
						crossFade: true,
					},
				},
				wrapper: 'relative w-full bg-transparent overflow-hidden',
				slider: 'h-full min-h-full',
				sliderItem: '!flex items-center aspect-[4/3] sm:aspect-[3/1] [&>*]:min-w-full [&>*>*>*]:aspect-[4/3] [&>*>*>*]:sm:aspect-none [&>*>*>*>*]:w-auto [&>*>*>*>img]:min-w-full [&>*>*>*>*]:max-w-none [&>*>*>*>*]:relative [&>*>*>*>*]:left-1/2 [&>*>*>*>*]:-translate-x-1/2 overflow-hidden',
				slideContent: 'absolute top-0 w-full flex justify-start items-center z-10 h-full [&>*:not(.image-container)]:z-10 [&>*>*]:flex [&>*>*]:flex-col [&>*>*]:items-start [&>*>*]:gap-4 [&>*>*>.nk-title]:text-3xl [&>*>*>.nk-title]:lg:text-5xl [&>*>*>.nk-title]:bg-secondary-800 [&>*>*>.nk-title]:px-2 [&>*>*>.nk-text]:bg-primary-600 [&>*>*>.nk-text]:text-md [&>*>*>.nk-text]:p-2 [&>*>*>.nk-text]:-order-1 [&>*>*>.nk-text]:!m-0 [&>*>*>.nk-text]:px-2 [&>*>*>.nk-text]:lg:px-4 [&>*>*>.nk-text]:py-1 [&>*>*>.nk-text]:lg:py-2 [&>*>*>.nk-text]:uppercase [&>*>*>.text-primary-element]:uppercase [&>*>*>.text-primary-element]:!py-2 [&>*>*>.text-primary-element]:!px-4 [&>*>*>.text-primary-element]:lg:!py-4 [&>*>*>.text-primary-element]:lg:!px-8 before:content-none sm:before:content-[""] before:block before:absolute before:left-0 before:-bottom-1 before:w-full before:h-40 before:lg:h-60 before:z-10 before:bg-gradient-to-t before:from-neutral-50 before:pointer-events-none',
				slideBackgroundImage:
					'absolute top-0 left-0 object-cover lazyload h-full w-full',
				controls:
					'flex justify-center items-center gap-6 sm:px-2 py-2 static absolute sm:right-16 lg:right-4 bottom-0 sm:bottom-8 z-10 bg-white/20 sm:rounded-full sm:shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[5px] sm:border sm:border-white/30 w-full sm:w-auto',
				buttonWrapper: 'flex justify-center items-center',
				button:
					'transition justify-center items-center text-center text-white sm:text-neutral-900 text-lg inline-flex opacity-100 hover:opacity-80 scale-100 hover:scale-110',
				buttonLeft: 'text-md',
				buttonLeftIcon: 'chevron-left',
				buttonRight: 'text-md',
				buttonRightIcon: 'chevron-right',
				buttonDisabled: 'opacity-50 cursor-not-allowed',
				paginationWrapper: '',
				pagination: 'flex flex-wrap items-end list-none justify-center gap-1',
				paginationButton:
					'relative size-5 before:absolute before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:size-3 before:rounded-full before:border-2 before:border-white sm:before:border-neutral-900 before:pointer-events-none hover:before:opacity-80 before:scale-100 hover:before:scale-110 before:transition',
				paginationButtonActive: 'is-active before:bg-white sm:before:bg-neutral-900',
			},
		},
	},
	NkDate: {
		variants: {
			default: {
				wrapper:
					'inline-flex flex-col text-neutral-on-surface text-center size-16 justify-center items-center rounded-full bg-secondary-700',
				day: 'text-xl font-bold text-white leading-[24px]',
				month: 'text-sm text-white opacity-85 uppercase tracking-wide leading-[16px]',
			},
		},
	},
	NkIcon: {
		icons: globals.icons,
	},
	NkImage: {
		classes: {
			wrapper: 'relative',
			copyright:
				'inline-block absolute z-30 opacity-75 leading-none rounded-full p-1 text-white text-sm',
			container: 'block relative w-full',
			image:
				'max-w-full w-full lazyload transition-opacity duration-500 ease-out delay-100',
			noteLabelGallery:
				'inline-flex items-center bg-primary-element bg-opacity-75 mb-2 px-2 py-1 text-white text-sm rounded whitespace-no-wrap',
			noteLabelZoom:
				'absolute bottom-0 right-0 inline-flex items-center bg-black bg-opacity-75 m-2 px-2 py-1 text-white text-sm rounded whitespace-no-wrap',
			noteLabelIcon: 'mr-1 text-base',
			figcaption: 'h-auto relative italic my-2 text-base',
		},
		aspectRatios: globals.aspectRatios,
		positions: globals.positions,
		floats: globals.floats,
		imageSrcset: [480, 640, 768, 1024, 1280, 1920],
	},
	NkNav: {
		fixedClasses: 'nk-nav',
		variants: {
			default: {
				wrapper: '',
				item: 'nk-nav-item border-b border-neutral-border text-md',
				title: 'font-bold',
				text: '',
				content: 'inline-block text-base underline',
				link: 'block py-3 px-2 transition duration-300 group text-primary-text hover:text-primary-text--hover link-active:bg-primary-surface link-active:text-primary-on-surface',
				prependIcon: {
					icon: 'chevron-right',
					class: 'mr-1',
				},
			},
			footprint: {
				wrapper: 'flex flex-wrap divide-x divide-neutral-border -mx-2',
				item: 'nk-nav-item',
				title: '',
				text: '',
				link: 'flex items-center py-1 px-2 text-primary-text hover:text-primary-text--hover transition duration-300 group',
				prependIcon: false,
			},
			resources: {
				wrapper: 'border border-neutral-border rounded-sm',
				item: 'nk-nav-item border-b border-neutral-border',
				link: 'flex items-center flex-no-wrap p-3 text-primary-text hover:text-primary-text--hover  transition duration-300 group no-underline',
				content: 'px-3 flex-1 overflow-hidden underline',
				longtext: 'whitespace-normal',
				prependIcon: {
					icon: 'file',
					color: 'primary-500',
					size: 'xl',
					inline: false,
				},
				appendIcon: {
					icon: 'download',
					color: 'type',
					size: 'xl',
					inline: false,
				},
			},
			links: {
				wrapper: 'border border-neutral-border rounded-sm',
				item: 'nk-nav-item border-b border-neutral-border',
				link: 'flex items-center flex-no-wrap py-3 px-2 text-primary-text hover:text-primary-text--hover transition duration-300 group no-underline',
				content: 'truncate px-3 underline',
				text: 'italic truncate',
				appendIcon: {
					icon: 'chevron-right',
					color: 'primary-500',
					size: 'xl',
					inline: false,
				},
			},
			abc: {
				wrapper: 'flex flex-wrap justify-start',
				item: 'nk-nav-item',
				title: '',
				text: '',
				link: 'size-10 flex justify-center items-center rounded-full !text-neutral-900 bg-transparent duration-150 focus:bg-neutral-100 focus:text-neutral-900 hover:bg-neutral-100 hover:text-neutral-900 link-active:bg-primary-600 link-active:!text-white',
			},
		},
	},
	NkPagination: {
		classes: {
			wrapper: 'nk-pagination my-3',
			list: 'flex items-center list-none -mx-1',
			item: 'text-sm px-1',
			link: 'flex justify-center items-center size-10 rounded-full terxt-neutral-900 bg-transparent duration-150 hover:bg-neutral-100 focus:bg-neutral-100',
			linkActive: 'flex justify-center items-center size-10 rounded-full text-white bg-primary-600 hover:text-white hover:bg-primary-500',
			button:
				'inline-flex justify-center items-center size-10 rounded-full border-solid border border-element-border p-2 bg-primary-element text-primary-on-element rounded-full hover:bg-primary-element--hover hover:text-primary-on-element focus:bg-primary-element--active focus:text-primary-on-element',
			buttonDisabled:
				'inline-flex justify-center items-center size-10 bg-neutral-100 rounded-full text-neutral-500 p-2 cursor-not-allowed',
			currentItem: '',
		},
		justifyContent: globals.justifyContent,
		firstPageIcon: 'firstPage',
		previousPageIcon: 'previousPage',
		nextPageIcon: 'nextPage',
		lastPageIcon: 'lastPage',
	},
	NkSidebar: {
		classes: {
			wrapper: 'space-y-12 bg-white rounded-xl my-0 -mx-8 lg:-m-8 p-8',
		},
	},
};

export {settings, globals};
